import { combineReducers } from 'redux';
import ActiveConversationReducer from './active_conversation';
import ConversationsReducer from './conversations';
import CurrentUserReducer from './current_user';
import MessageCreatorReducer from './message_creator';
import ConversationCreatorReducer from './conversation_creator';
import ConversationDetailsReducer from './conversation_details';
import ParticipantsReducer from './participants';
import SearchReducer from './search';

const RootReducer = combineReducers({
  activeConversation: ActiveConversationReducer,
  conversations: ConversationsReducer,
  currentUser: CurrentUserReducer,
  messageCreator: MessageCreatorReducer,
  conversationCreator: ConversationCreatorReducer,
  conversationDetails: ConversationDetailsReducer,
  participants: ParticipantsReducer,
  search: SearchReducer
});

export default RootReducer;
